class UserAgentUtils {
    public static isMobile: any = {
        Android() {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        iPhone() {
            return navigator.userAgent.match(/iPhone/i);
        },
        iPad() {
            return navigator.userAgent.match(/iPad/i);
        },
        iPod() {
            return navigator.userAgent.match(/iPod/i);
        },
        Opera() {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows() {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any() {
            return (this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows());
        },
    };
    public static isInsideCVApp: any = {
        Android() {
            return navigator.userAgent.indexOf('inNativeShell') > -1;
        },
        IOS() {
            return navigator.userAgent.indexOf('isInsideIOSApp') > -1;
        },
        any() {
            return (this.Android() || this.IOS());
        },
    };
}

export default UserAgentUtils;
